import {getterSetter, isSet,isEmpty, getFormObject, isNavigationKeyPressed,isMobile, getSiteVisitTimeSlots, formatDate} from '../../utils/common';
import {requirementService} from '../../services/requirementService';
import {addEvent} from '../../utils/gaService';
import {getCookie} from '../../services/cookieService'
import 'js-datepicker/dist/datepicker.min.css';
import {Component, register} from '../../core';
import constants from '../../cityConstant.js';
import '../../services/gaService.js';
import datepicker from 'js-datepicker'
//import '../constants/citiesConstant'



// The initial state of this component
const initialState = {
    cities: [
        ...constants.data.topCities,
        ...constants.data.allCities
        
    ],

    cityIds: [],
    cityNavIdx: -1,
    elCityNavLast: null,
    countryNavIdx: -1,
    elCountryNavLast: null,
    amenities: ['WIRELESS AND WIRED INTERNET','COFFEE','DAILY CLEANING','24/7 BUILDING ACCESS','BUSINESS-CLASS PRINTERS','FRONT DESK SERVICES','CRAFT ON DRAFT','PROFESSIONAL & SOCIAL EVENTS','UNIQUE COMMON AREAS','FRESH DRINKING WATER','MAIL & PACKAGE HANDLING','VEHICLE PARKING','COMMUNITY MANAGERS','OFFICE-SUPPLIES','GLOBAL NETWORK','ACCESS CONTROL','SIT-TO-STAND DESKS','PHONE & MEETING ROOMS','NAP/WELLNESS ROOMS','FREE STATIONERIES','YOGA','SIPPER STATION','OUTDOOR SPACE'].sort(),
    price: {
        "WORK_DESK" : {
            "hourly":69,
            "daily": 550,
            'weekly': 2750,
            'monthly': 11000
        },
        "MANAGER_CABIN": {
            "hourly":75,
            "daily": 600,
            'weekly': 3000,
            'monthly': 12000
        },
        "MEETING_ROOM": {
            "hourly":99,
            "daily": 750,
            'weekly': 3750,
            'monthly': 15000
        },
        "TRAINING_ROOM": {
            "hourly":125,
            "daily": 999,
            'weekly': 4995,
            'monthly': 19980
        },
        "PRIVATE_CABIN": {
            "hourly":99,
            "daily": 700,
            'weekly': 3500,
            'monthly': 14000
        },
        "EVENT_SPACE": {
            "hourly":1250,
            "daily": 10000,
            "weekly": 50000,
            "monthly": 200000
        }
    },
    enrichmentFormPayload: {
        requirementId: '',
        businessType: '',
        employeeStrength: '',
        requirementFrequency: '',
        rentDuration: '',
        budget: '',
        noOfOfficeLocations: '',
        requiredWithIn: '',
        additionalInfo: ''
    }
};


// Component fragments
const fragments = {
    amenities: (amenities = []) => amenities.reduce((html, amenity, idx) => html + `
        <li data-ref="amenity">
            <input type="checkbox" class="amenitiesval no-event" value="${amenity}" id="${idx}" />
            <label for="${idx}">${amenity}</label>
        </li>
    `, ''),
};

// Analytics events for this page
const analytics = {
    GA: {
        packagedRequirementSubmitClicked: () => {
            addEvent('QuikrHomes', 'QH_coworks_leadform_requirementsubmit', 'QH_coworks_leadform_requirementsubmit_click');
        }
    }
};

/**
 * Cowork contact component
 */
export class CoworkHomeDetailComponent extends Component {

    static alias = 'cowork-detail';

    constructor(el) {
        super(el, initialState);
    }

    onComponentLoaded() {
        this.handleCitySearch = this.handleCitySearch.bind(this);
        this.handleCitySearchFocusOut = this.handleCitySearchFocusOut.bind(this);
        this.handleCitySuggestionNavigation = this.handleCitySuggestionNavigation.bind(this);
        this.handleCitySelection = this.handleCitySelection.bind(this);
        this.handleWorkStationSelection = this.handleWorkStationSelection.bind(this);
        this.handleDurationSelection = this.handleDurationSelection.bind(this);
        this.handleToggleAmenitiesDropdown = this.handleToggleAmenitiesDropdown.bind(this);
        this.handleSeatMinus = this.handleSeatMinus.bind(this);
        this.handleSeatPlus = this.handleSeatPlus.bind(this);
        this.handleDaysMinus = this.handleDaysMinus.bind(this);
        this.handleDaysPlus = this.handleDaysPlus.bind(this);
        this.handleSiteVisitTime = this.handleSiteVisitTime.bind(this);
        this.handleStartDate = this.handleStartDate.bind(this);
        this.handleSiteVisitDate = this.handleSiteVisitDate.bind(this);
        this.handleSiteVisitDropDown = this.handleSiteVisitDropDown.bind(this);
        this.handleLocalitySearch = this.handleLocalitySearch.bind(this);
        this.handleLocalitySearchFocusOut = this.handleLocalitySearchFocusOut.bind(this);
        this.handleLocalitySuggestionNavigation = this.handleLocalitySuggestionNavigation.bind(this);
        this.handleLocalitySelection = this.handleLocalitySelection.bind(this);
        this.handleSubmitDetail = this.handleSubmitDetail.bind(this);
        this.onClickSelectAmenity = this.onClickSelectAmenity.bind(this);
        
        // Initialize the detail form
        this.initializeContactForm();
    }

    /**
     * Initializes the detail form
     */
    initializeContactForm() {
        // Init
        if (document.getElementById('co_workPopup')) {
            const modalClass = document.getElementById('co_workPopup').classList;
            if (modalClass.contains('leadenrichmentform')) {
                document.getElementById('co_workPopup').classList.remove('leadenrichmentform');
            }
            if (!modalClass.contains('co_workPopup')) {
                document.getElementById('co_workPopup').classList.add('co_workPopup');
            }
        }

        // Initialize form lead enrichment form
        this.initializeLeadenrichmentForm();

        // Initialize the city search
        this.initializeCitySuggest();
        this.initializeAmenities();
        this.initalizeStartDateSelection();
        this.initalizeScheduleDateSelection();
        this.initializePriceCaluclation();
    }

    initializeLeadenrichmentForm() {
        [...this.refs.enrichmentForm.querySelectorAll('[enrichoption]')]
            .forEach((elInput) => {
                elInput.addEventListener('click', ({target: {dataset: {value, field}, innerHTML: txtVal}}) => {
                    this.refs[field].innerHTML = txtVal;
                    this.state.enrichmentFormPayload[field] = value;

                    if (!elInput.parentElement.classList.contains('slected')) {
                        elInput.parentElement.classList.add('slected');
                    }
                });
            });

            this.refs.additionalInfo.addEventListener('keyup', ({target: {value: textVal}}) => {
                this.state.enrichmentFormPayload.additionalInfo = textVal;
                if (textVal.length < 1000) {
                    this.refs.enrichLeadError.innerHTML = '';
                    if (!this.refs.enrichLeadError.classList.contains('hide')) {
                        this.refs.enrichLeadError.classList.add('hide');
                    }
                } else {
                    this.refs.enrichLeadError.innerHTML = 'Max 1000 Characters';
                    this.refs.enrichLeadError.classList.remove('hide');
                }
            });

            this.refs.additionalInfo.addEventListener('paste', ({target: {value: textVal}}) => {
                if (textVal.length > 1000) {
                    this.refs.enrichLeadError.innerHTML = 'Max 1000 Characters';
                    this.refs.enrichLeadError.classList.remove('hide');
                    this.refs.additionalInfo.value = textVal.substring(0, 1000);
                    this.state.enrichmentFormPayload.additionalInfo = textVal.substring(0, 1000);
                }
            });
    }

    initializePriceCaluclation() {
        let worksStationval = (this.refs.workStation.innerText).toLowerCase();
        let worksStation = worksStationval.replace(' ','_');
        let duration = (this.refs.duration.innerText).toLowerCase();
        let seats =this.refs.seats.innerText;
        let days =  this.refs.days.innerText;
        let priceval = parseInt(this.state.price[worksStation.toUpperCase()][duration]) * parseInt(seats) * parseInt(days);
        if(isSet(priceval)) {
            this.refs.priceRate.innerHTML = `&#8377; ${priceval}`
        }
        this.refs.priceRateValue.value = priceval

    }

    initalizeStartDateSelection()  {
        const scheduledate = datepicker(this.refs.startdate, {
            formatter: (input, date, instance) => {
                input.value = formatDate(date);
            },
            minDate: new Date(),
            onSelect: (instance, date) => {
                if(!isSet(date)) {
                    return;
                }
                this.handleStartDate(formatDate(date));
            }
        });
        this.handleStartDate(formatDate(new Date()));
    }
    
    initalizeScheduleDateSelection()  {
        const now = new Date();
        const hoursNow = now.getHours();
        if(hoursNow >= 20){
            now.setDate(now.getDate() + 1);
        }
        const scheduledate = datepicker(this.refs.scheduledate, {
            formatter: (input, date, instance) => {
                input.value = formatDate(date);
            },
            minDate: now,
            onSelect: (instance, date) => {
                if(!isSet(date)) {
                    return;
                }
                this.handleSiteVisitTime(date);
                this.handleSiteVisitDate(formatDate(date));
            }
        });
        this.handleSiteVisitDate(formatDate(new Date()));
        this.handleSiteVisitTime(new Date());
    }

    handleSiteVisitTime(date) {
        let dateSelected = formatDate(date);
        let defaultDate = formatDate(new Date());
        let scheduleVisitTimeDropDown = this.refs.scheduleVisittimeDropdown; 
        let scheduleVisittime = this.refs.scheduleVisittime;
        scheduleVisitTimeDropDown.innerHTML = '';
        scheduleVisittime.innerHTML ='';
        if(dateSelected == defaultDate) {
            let siteVisitTimeValues = getSiteVisitTimeSlots(9, 20, 1,2, new Date());
            scheduleVisittime.innerHTML = siteVisitTimeValues[0].display;
            siteVisitTimeValues.forEach(function (value, index) {
                scheduleVisitTimeDropDown.innerHTML +=`<li data-value= "${value.display}">${value.display}</li>`
            });
        } else {
            let siteVisitTimeValues = getSiteVisitTimeSlots(9, 20, 1,2, new Date(dateSelected));
            scheduleVisittime.innerHTML = siteVisitTimeValues[0].display;
            siteVisitTimeValues.forEach(function (index, value) {
                scheduleVisitTimeDropDown.innerHTML +=`<li data-value= "${index.display}">${index.display}</li>`
            });
        }
    }

    handleSiteVisitDropDown({target: {textContent, dataset: {value}}}) {
        if (!value) {
            return;
        }
        this.refs.scheduleVisittime.innerText = textContent;
    }

    handleStartDate(date) {
        this.refs.startdate.value = date; 
    }

    handleSiteVisitDate(date) {
        this.refs.scheduledate.value = date; 
    }

    /**
     * Event handler to handle Lead Enrichment submission
     */
    enrichSubmitClick() {
        // Validate 
        const formData = this.state.enrichmentFormPayload;
        this.refs.enrichLeadError.innerHTML = '';
        if (!this.refs.enrichLeadError.classList.contains('hide')) {
            this.refs.enrichLeadError.classList.remove('hide');
        }
        if (formData.requirementId !== '') {
            
            this.submitEnrichmentLead(formData)
                .catch((err) => {
                    // Display an error
                    this.refs.enrichLeadError.innerHTML = 'Something went wrong!';
                    this.refs.enrichLeadError.classList.remove('hide');
                    throw err;
                })
                .then(() => {
                    this.showSuccess();
                    this.removeEnrichListener();
                })
                .catch(() => {});
        } else {
            this.refs.enrichLeadError.innerHTML = 'Something went wrong';
            this.refs.enrichLeadError.classList.remove('hide');
        }
    }

    /**
     * Remove enrich submit listener
     */
    removeEnrichListener() {
        this.refs.enrichSubmit.removeEventListener('click', this.enrichSubmitClick);
    }

    /**
     * Initializes the city suggest
     */
    initializeCitySuggest() {
        let that = this;
        this.state.cityIds = this.state.cities.map((city) => +city.id);

        // Render the top cities as default
        this.renderTopCities(false);

        // Attach the event handlers for city suggestions
        this.refs.citySearch.addEventListener('input', this.handleCitySearch);
        this.refs.citySearch.addEventListener('blur', this.handleCitySearchFocusOut);
        this.refs.citySearch.addEventListener('keydown', this.handleCitySuggestionNavigation);
        this.refs.cityDropdown.addEventListener('click', this.handleCitySelection);
        this.refs.workStationDropdown.addEventListener('click', this.handleWorkStationSelection);
        this.refs.durationDropdown.addEventListener('click', this.handleDurationSelection);
        this.refs.scheduleVisittimeDropdown.addEventListener('click', this.handleSiteVisitDropDown);
        this.refs.seatPlus.addEventListener('click', this.handleSeatPlus);
        this.refs.seatMinus.addEventListener('click', this.handleSeatMinus);
        this.refs.daysPlus.addEventListener('click', this.handleDaysPlus);
        this.refs.daysMinus.addEventListener('click', this.handleDaysMinus);

        this.refs.localitySearch.addEventListener('input', this.handleLocalitySearch);
        this.refs.localitySearch.addEventListener('blur', this.handleLocalitySearchFocusOut);
        this.refs.localitySearch.addEventListener('keydown', this.handleLocalitySuggestionNavigation);
        this.refs.localityDropdown.addEventListener('click', this.handleLocalitySelection);

        this.refs.submitDetail.addEventListener('click', this.handleSubmitDetail);
        this.refs.enrichSubmit.addEventListener('click', this.enrichSubmitClick.bind(that));
        
    }


    handleSubmitDetail() {
        // Validate the form
        const formData = getFormObject(this.refs.detailForm);
        const validationErrors = this.getValidationErrors(formData);

        // Ensure the form is valid
        if (validationErrors) {
            this.showFormErrors(validationErrors);
            return;
        }

        if (document.getElementById('reqId')) {
            this.state.enrichmentFormPayload.requirementId = document.getElementById('reqId').value;
        }

        // Clear the form errors
        this.clearFormErrors();

        analytics.GA.packagedRequirementSubmitClicked();
        requirementService.addCoworkRequirement(this.coworkDefaultPayLoad());
        this.showSuccess();
    }

    /**
     * Clears all the form errors
     */
    clearFormErrors(fields = []) {
        if (fields && fields.length > 0) {
            // Populate the errors
            fields.map((fieldName) => this.refs.detailForm.querySelector(`.error[for=${fieldName}]`))
                .forEach((elError) => (elError.textContent = ''));
        } else {
            // Clear all the errors
            this.refs.detailForm.querySelectorAll('.error[for]')
                .forEach((elError) => (elError.textContent = ''));
        }
    }

    coworkDefaultPayLoad() {
        let worksStationval = (this.refs.workStation.innerText).toLowerCase();
        let worksStation = worksStationval.replace(' ','_').toUpperCase();
        let duration = (this.refs.duration.innerText).toLowerCase();
        let seats =this.refs.seats.innerText;
        let days =  this.refs.days.innerText;
        let localityId = this.refs.hiddenLocalityId.value || '';
        let localityName = this.refs.localitySearch.value || '';
        let cityId = this.refs.hiddenCityId.value || '';
        let cityName = this.refs.citySearch.value || '';
        let comments = this.refs.comments.value || '';
        let amenitiesList = [...document.querySelectorAll('.amenitiesval:checked')].map(el => el.value);
        let startdate = (isSet(this.refs.startdate.value)) ? new Date(this.refs.startdate.value).getTime() : '';
        let scheduledate = (isSet(this.refs.scheduledate.value)) ? new Date(this.refs.scheduledate.value).getTime() : '';
        //console.log(amenitiesList);
        let scheduleVisittimes = (isSet(this.refs.scheduleVisittime.innerText)) ? this.refs.scheduleVisittime.innerText : '';
        let scheduleVisittimeStart = (isSet(scheduleVisittimes)) ? scheduleVisittimes.split("-")[0] : '';
        let scheduleVisittimesEnd = (isSet(scheduleVisittimes)) ? scheduleVisittimes.split("-")[1] : '';
        let priceVal =this.refs.priceRateValue.value;

        let source = 'COWORK_LANDING_PAGE';
        if(globals.pageType == 'CoworkVAP') {
            source = 'COWORK_VAP';
        } 
        let channel = isMobile() ? 'MOBILE': 'DESKTOP';


        return {
                "source": source,
                "propertyId":1000,
                "userId": getCookie('__u') || '',
                "userName":  getterSetter.get('name')|| '',
                "userEmail": getterSetter.get('email'),
                "userMobile": getterSetter.get('mobile'),
                "channel":channel,
                "id": document.getElementById('reqId').value || '',
                "propertyId":1000,
                "startDate": startdate,
                "cityName": cityName,
                "cityId": cityId,
                "localityName":localityName,
                "localityId" : localityId,
                "unitTypeList": worksStation.split(),
                "unitCount": seats,
                "durationUnit": duration.toUpperCase(),
                "duration": days,
                "amenitiesList":amenitiesList,
                "remarks":comments,
                "siteVisitRequest": {
                    "visitDate": scheduledate,
                    "visitSlotStart": scheduleVisittimeStart,
                    "visitSlotEnd": scheduleVisittimesEnd
                },
                "estimatedCost":priceVal,
                "referer":location.hostname
            }
    }

    showEnrichmentForm() {
        document.getElementById('co_workPopup').classList.add('leadenrichmentform');
        document.getElementById('co_workPopup').classList.remove('co_workPopup');
        this.refs.detailFormContainer.classList.add('hide');
        this.refs.enrichmentForm.classList.remove('hide');
    }

    showSuccess() {
        const isEnriched = localStorage.getItem('isEnriched');

        if (isEnriched) {
            const modalClass = document.getElementById('co_workPopup').classList;
            if (modalClass.contains('leadenrichmentform')) {
                document.getElementById('co_workPopup').classList.remove('leadenrichmentform');
            }
            if (!modalClass.contains('co_workPopup')) {
                document.getElementById('co_workPopup').classList.add('co_workPopup');
            }

            this.refs.detailFormContainer.classList.remove('hide');
            this.refs.enrichmentForm.classList.add('hide');

            this.refs.detailForm.classList.add('hide');
            this.refs.thankuPopup.style.display = 'block';
        } else {
            this.showEnrichmentForm();
        }
    }

    initializeAmenities() {
        this.renderAmenities(this.state.amenities);
        this.refs.amenitiesLabel.addEventListener('click', this.handleToggleAmenitiesDropdown);
        this.refs.amenitiesList.addEventListener('click', this.onClickSelectAmenity);
        var divToHide = document.getElementById('amenitieslist');
        document.onclick = function(e){
            if (!document.getElementById('amenitiesdropdwnlist').contains(e.target)){
                document.getElementById('amenitiesdropdwnlist').classList.remove('open');
            }
        };
    }

    onClickSelectAmenity() {
        let amentities = [...this.root.querySelectorAll('.amenitiesval:checked')].map(el => el.value);
        this.refs.amenitiesLabel.innerHTML = (!isEmpty(amentities)) ? amentities.length >1 ? `${amentities[0]} & ${amentities.length - 1} More <svg class="icon-down" width="15px" height="15px">
                                                    <use xlink:href="#icon-dwon" fill="#333"></use>
                                                </svg>` : `${amentities[0]}<svg class="icon-down" width="15px" height="15px">
                                                    <use xlink:href="#icon-dwon" fill="#333"></use>
                                                </svg>`  : `Select Amenities <svg class="icon-down" width="15px" height="15px">
                                                    <use xlink:href="#icon-dwon" fill="#333"></use>
                                                </svg>`;
    }

    renderAmenities(amenities = []) {
        this.refs.amenitiesList.innerHTML = fragments.amenities(amenities);
    }

    handleToggleAmenitiesDropdown(ev) {
        if (this.refs.amenitiesDropdown.classList.contains('open')) {
            this.refs.amenitiesDropdown.classList.remove('open');
        } else {
            this.refs.amenitiesDropdown.classList.add('open');
        }
    }

    handleSeatPlus() {
        let seatCount = this.refs.seats.innerText;
        this.refs.seats.innerText = parseInt(seatCount)+1;
        this.initializePriceCaluclation();
    }

    handleSeatMinus() {
        let seatCount = this.refs.seats.innerText;
        if(parseInt(seatCount)>1) {
            this.refs.seats.innerText = parseInt(seatCount)-1;
            this.initializePriceCaluclation();
        }
        return;
    }

    handleDaysPlus() {
        let daysCount = this.refs.days.innerText;
        this.refs.days.innerText = parseInt(daysCount)+1;
        this.initializePriceCaluclation();
    }

    handleDaysMinus() {
        let daysCount = this.refs.days.innerText;
        if(parseInt(daysCount)>1) {
            this.refs.days.innerText = parseInt(daysCount)-1;
            this.initializePriceCaluclation();
        }
        return;
    }


    handleWorkStationSelection({target: {textContent, dataset: {value}}}) {
        if (!value) {
            return;
        }

        this.refs.labelSeats.innerText = textContent.replace("_", " ");
        this.refs.workStation.innerText = textContent;
        this.initializePriceCaluclation();
    }

    handleDurationSelection({target: {textContent, dataset: {value}}}) {
        if (!value) {
            return;
        }
        this.refs.duration.innerText = textContent;
        if(textContent == 'Monthly') {
            this.refs.labelDays.innerText = 'Months'
        } if(textContent == 'Daily') {
            this.refs.labelDays.innerText = 'Days'
        } 
        else if(textContent == 'Weekly') {
            this.refs.labelDays.innerText = 'Weeks'
        } else {
            this.refs.labelDays.innerText = 'Hours'
        }
        this.initializePriceCaluclation();
    }

    /**
     * Event handler to load city suggestions based on search
     * 
     * @param {KeyboardEvent} param0 the `input` event
     */
    handleCitySearch({target: {value}}) {
        // Reset the selected city hidden field
        this.refs.hiddenCityId.value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            this.renderTopCities();
        } else {
            // Search for the city by name based on the search string
            const matchingCities = this.state.cities
                .filter((city) => city.name.toLowerCase().startsWith(value));

            // Render the matching cities
            this.renderCitySuggestions(matchingCities);
        }
    }

    /**
     * Event handler to handle focus out
     * 
     * @param {FocusEvent} param0 the `blur` event
     */
    handleCitySearchFocusOut(ev) {
        if (ev.relatedTarget) {
            this.refs.cityDropdown.parentElement.classList.remove('open');
        }
    }


    /**
     * Event handler to navigate the city suggestions dropdown
     * 
     * @param {KeyboardEvent} ev the `keydown` event
     */
    handleCitySuggestionNavigation(ev) {
        // Check if any key other than arrow key is pressed
        if (!isNavigationKeyPressed(ev)) {
            return;
        }

        const elSuggestions = this.refs.cityDropdown.children;
        const totalSuggestions = this.refs.cityDropdown.childElementCount;

        // Inflate the dropdown if not already
        if (!this.refs.cityDropdown.parentElement.classList.contains('open')) {
            this.refs.cityDropdown.parentElement.classList.add('open');
        }

        if (this.state.elCityNavLast) {
            this.state.elCityNavLast.classList.remove('active');
        }

        // Update the cursor
        if (40 === ev.keyCode && this.state.cityNavIdx < (totalSuggestions - 1)) {
            this.state.cityNavIdx += 1;
            this.state.elCityNavLast = elSuggestions.item(this.state.cityNavIdx);
            this.state.elCityNavLast.classList.add('active');

            // Scroll down
            if (this.state.elCityNavLast.offsetTop + this.state.elCityNavLast.scrollHeight > this.refs.cityDropdown.clientHeight) {
                this.refs.cityDropdown.scrollTop = this.refs.cityDropdown.scrollTop + this.state.elCityNavLast.scrollHeight;
            }
        } else if (38 === ev.keyCode && this.state.cityNavIdx > 0) {
            this.state.cityNavIdx -= 1;
            this.state.elCityNavLast = elSuggestions.item(this.state.cityNavIdx);
            this.state.elCityNavLast.classList.add('active');

            // Scroll Up
            if (this.state.elCityNavLast.offsetTop + this.state.elCityNavLast.scrollHeight > this.refs.cityDropdown.clientHeight) {
                this.refs.cityDropdown.scrollTop = this.refs.cityDropdown.scrollTop - this.state.elCityNavLast.scrollHeight;
            }
        } else if (13 === ev.keyCode) {
            ev.preventDefault();
            elSuggestions.item(this.state.cityNavIdx).click();
        }
    }

    /**
     * Event handler to handle city selection
     * 
     * @param {MouseEvent} param0 the `click` event 
     */
    handleCitySelection({target: {textContent, dataset: {value}}}) {
        if (!value) {
            this.refs.localitySearch.value = '';
            this.refs.hiddenLocalityId.value = '';
            this.refs.localitySearch.disabled = true;
            return;
        }

        // Store the selected city id a hidden field
        this.refs.hiddenCityId.value = value;
        this.refs.citySearch.value = textContent;
        this.refs.citySearch.focus();
        this.refs.localitySearch.disabled = false;
        this.clearFormErrors();
    }

    /**
     * Renders the top cities
     */
    renderTopCities(inflate = true) {
        this.renderCitySuggestions(this.state.cities, inflate);
    }

    /**
     * Renders cities in the city dropdown 
     * 
     * @param {Array} cities the cities to render in the dropdown
     */
    renderCitySuggestions(cities = [], inflate = true) {
        // Inflate the dropdown
        if (inflate) {
            this.refs.cityDropdown.parentElement.classList.add('open');
        }

        this.refs.cityDropdown.innerHTML = cities.reduce((html, city) => html + `
            <li data-value="${city.id}">${city.name}</li>
        `, '');
    }


    handleLocalitySearch({target: {value}}) {
        // Reset the selected city hidden field
        this.refs.hiddenLocalityId.value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (value.length >=3) {
            let post = {
                'query': value,
                'cityId': this.refs.hiddenCityId.value,
                'limit': 5
            };

            let postData = new FormData();
            postData.append("localitySuggest", JSON.stringify( post ))
            fetch('/homes/re2/postAd/localitySearch', {
                method : 'POST',
                body : postData
            }).then(function(res){
                return res.json();
            }).then(function(data){
                if(data){
                    localityDropDown.innerHTML = data.reduce((html, locality) => html + `
                        <li data-value="${locality.id}">${locality.title}</li>
                    `, '');
                }
           });
        } 
    }

    renderLocalitySuggestions(locality = [], inflate = true) {
        // Inflate the dropdown
        if (inflate) {
            this.refs.localityDropdown.parentElement.classList.add('open');
        }

        this.refs.localityDropdown.innerHTML = locality.reduce((html, city) => html + `
            <li data-value="${locality.id}">${locality.title}</li>
        `, '');
    }

    handleLocalitySelection({target: {textContent, dataset: {value}}}) {
        if (!value) {
            return;
        }

        // Store the selected city id a hidden field
        this.refs.hiddenLocalityId.value = value;
        this.refs.localitySearch.value = textContent;
        this.refs.localitySearch.focus();
        this.clearFormErrors();
    }

    handleLocalitySearchFocusOut(ev) {
        if (ev.relatedTarget) {
            this.refs.localityDropdown.parentElement.classList.remove('open');
        }
    }

    handleLocalitySuggestionNavigation(ev) {
        // Check if any key other than arrow key is pressed
        if (!isNavigationKeyPressed(ev)) {
            return;
        }

        const elSuggestions = this.refs.localityDropdown.children;
        const totalSuggestions = this.refs.localityDropdown.childElementCount;

        // Inflate the dropdown if not already
        if (!this.refs.localityDropdown.parentElement.classList.contains('open')) {
            this.refs.localityDropdown.parentElement.classList.add('open');
        }

        if (this.state.elLocalityNavLast) {
            this.state.elLocalityNavLast.classList.remove('active');
        }

        // Update the cursor
        if (40 === ev.keyCode && this.state.localityNavIdx < (totalSuggestions - 1)) {
            this.state.localityNavIdx += 1;
            this.state.elLocalityNavLast = elSuggestions.item(this.state.localityNavIdx);
            this.state.elLocalityNavLast.classList.add('active');

            // Scroll down
            if (this.state.elLocalityNavLast.offsetTop + this.state.elLocalityNavLast.scrollHeight > this.refs.localityDropdown.clientHeight) {
                this.refs.localityDropdown.scrollTop = this.refs.localityDropdown.scrollTop + this.state.elLocalityNavLast.scrollHeight;
            }
        } else if (38 === ev.keyCode && this.state.localityNavIdx > 0) {
            this.state.localityNavIdx -= 1;
            this.state.elLocalityNavLast = elSuggestions.item(this.state.localityNavIdx);
            this.state.elLocalityNavLast.classList.add('active');

            // Scroll Up
            if (this.state.elLocalityNavLast.offsetTop + this.state.elLocalityNavLast.scrollHeight > this.refs.localityDropdown.clientHeight) {
                this.refs.localityDropdown.scrollTop = this.refs.localityDropdown.scrollTop - this.state.elLocalityNavLast.scrollHeight;
            }
        } else if (13 === ev.keyCode) {
            ev.preventDefault();
            elSuggestions.item(this.state.localityNavIdx).click();
        }
    }

    /**
     * Validate the form data and returns the validity
     * 
     * @param {Object} formData Cowork requirement form data
     */
    getValidationErrors(formData, validators = []) {
        const validity = {
            city: {
                isValid: isSet(formData.cityId) && this.state.cityIds.indexOf(+formData.cityId) >= 0 && isSet(formData.city) && !isEmpty(formData.city),
                message: 'Please select a city'
            },
            locality: {
                isValid: isSet(formData.localityId) && isSet(formData.locality) && !isEmpty(formData.locality),
                message: 'Please select a locality'
            }
        };

        return Object.keys(validity)
            .filter((v) => 0 === validators.length || validators.includes(v))
            .every((v) => validity[v].isValid) ? null : Object.keys(validity)
                .filter((v) => 0 === validators.length || validators.includes(v))
                .reduce((errors, field) => {
                    if (!validity[field].isValid) {
                        errors[field] = validity[field];
                    }

                    return errors;
                }, {});
    }

    /**
     * Shows the form validation errors 
     * 
     * @param {Object} errors form validation errors
     */
    showFormErrors(errors = {}) {
        // Clear the errors prior to displaying them
        this.clearFormErrors();

        if (errors) {
            // Populate the errors
            Object.keys(errors)
                .map((fieldName) => this.refs.detailForm.querySelector(`.error[for=${fieldName}]`))
                .forEach((elError) => (elError.textContent = (errors[elError.getAttribute('for')].message || errors[elError.getAttribute('for')])));
        }
    }

    submitEnrichmentLead() {
        const formData = this.state.enrichmentFormPayload;
        return requirementService.saveLeadEnrichment(formData).then((res) => {
            if (res.data) {
                localStorage.setItem('isEnriched', true);
                return res;
            }

            if (res.error) {
                throw res.error;
            }
        }).catch((err) => {
            throw err;
        });
    }

}

// Register this component
register(CoworkHomeDetailComponent);